// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

// Types
import type { I_UseValidate_Return } from "../index";

/** Функция-валидатор для поля "Email" */
export default function emailValidator(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: useTranslate("tiw__validation__email_required"),
        };
    }

    if (!/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
        return {
            status: false,
            message: useTranslate("tiw__validation__email_incorrect"),
        };
    }

    return {
        status: true,
        message: useTranslate("tiw__validation__success"),
    };
}
